import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

import { useStudentDetail } from "./StudentDetail.services";
import { Autocomplete, Button, Divider } from '@mui/material';
import { useParams } from 'react-router';
import { useEffect } from 'react';
import StudentCoursesTable from './StudentDetailCoursesTable';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const StudentDetail = () => {

  const { id } = useParams();

  const {
    studentDetails,
    getStudent,
    updateSuccess,
    updateFailure,
    handleClick,
    handleClose,
    originalDataChanged,
    updateCURP,
    updateName,
    updateLastname,
    updateRFC,
    updateStudent,
    updateCompany,
    updateShift,
    
    companies,
    getCompanies,
  } = useStudentDetail(id);

  useEffect(() => {
    getCompanies();
    getStudent();
  }, []);

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[900],
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
      }}
    >
      <Toolbar />
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Grid container spacing={3}>
          {/* Recent Orders */}
          <Grid item xs={12}>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h6" gutterBottom>
                Datos generales
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography>ID: {studentDetails.id}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="name"
                    name="name"
                    label="Nombre"
                    fullWidth
                    autoComplete="given-name"
                    variant="standard"
                    value={studentDetails.name}
                    onChange={(event) => {
                      updateName(event.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="lastname"
                    name="lastname"
                    label="Apellido"
                    fullWidth
                    autoComplete="given-lastname"
                    variant="standard"
                    value={studentDetails.lastname}
                    onChange={(event) => {
                      updateLastname(event.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} >
                  <TextField
                    required
                    id="curp"
                    name="curp"
                    label="CURP (opcional)"
                    fullWidth
                    inputProps={{ maxLength: 18, minLength: 18 }}
                    helperText={ studentDetails.curp?.length != 18 ? "Debe contener 18 caracteres" : null}
                    error={studentDetails.curp && studentDetails.curp?.length != 18  && true}
                    autoComplete="curp"
                    variant="standard"
                    value={studentDetails.curp ?? ""}
                    onChange={(event) => {
                      updateCURP(event.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} >
                  <TextField
                    required
                    id="rfc"
                    name="rfc"
                    label="RFC (opcional)"
                    fullWidth
                    inputProps={{ maxLength: 13, minLength: 12 }}
                    helperText={ !([12, 13].includes(studentDetails.rfc?.length ?? 0)) ? "Debe contener 12 o 13 caracteres" : null}
                    error={studentDetails.rfc && ![12, 13].includes(studentDetails.rfc?.length)}
                    autoComplete="rfc"
                    variant="standard"
                    value={studentDetails.rfc ?? ""}
                    onChange={(event) => {
                      updateRFC(event.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} >
                  <Autocomplete
                    value={studentDetails.company?.name ?? ""}
                    onInputChange={(event, newInputValue) => {
                      let company = companies.filter(company => company.name == newInputValue)
                      if (company.length > 0) {
                        updateCompany(company[0]);
                      }
                    }}
                    id="controllable-states-demo"
                    options={companies.map(company => company.name)}
                    renderInput={(params) => <TextField {...params} label="Compañía (opcional)" />}
                  />
                </Grid>
                <Grid item xs={12} >
                  <TextField
                    //required
                    id="shift"
                    name="Shift"
                    label="Guardia (opcional)"
                    fullWidth
                    autoComplete="shift"
                    variant="standard"
                    value={studentDetails.shift ?? ""}
                    onChange={(event) => {
                      updateShift(event.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                    <StudentCoursesTable
                      title={'Cursos'}
                      rows={studentDetails.trainings}
                    />
                  </Paper>
                </Grid>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Divider />
                  <Button
                    disabled={!originalDataChanged}
                    variant="contained"
                    sx={{ mt: 3, ml: 1 }}
                    onClick={() => { updateStudent() }}
                  >
                    Actualizar
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <Snackbar open={updateSuccess} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
          Participante actualizado
        </Alert>
      </Snackbar>
      <Snackbar open={updateFailure} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
          Error, no se pudo actualizar participante
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default StudentDetail;